import React, { Component } from 'react'

import {
  HInput,
  passParamsThrough
} from '../../../validation/HForm'

class DocumentsAdd extends Component {

  render() {
    return (
      passParamsThrough(<fieldset>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="lastName">Фамилия</label>
              <div className="form-element-data">
                <HInput h="true" className="input" type="text" name="lastName" id="lastName" />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="firstName">Имя</label>
              <div className="form-element-data">
                <HInput h="true" className="input" type="text" name="firstName" id="firstName" />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="middleName">Отчество</label>
              <div className="form-element-data">
                <HInput h="true" className="input" type="text" name="middleName" id="middleName" />
              </div>
            </div>
          </div>
        </div>
      </fieldset>, this.props)
    )
  }
}

export default DocumentsAdd
